import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Network } from "@dcl/schemas";
import { config } from "../../../config";
import { Mana } from "../../Mana";
import { ManaBalanceNumber, ManaBalancesWrapper } from "./ManaBalances.styled";
const ManaBalances = React.memo((props) => {
    const { manaBalances, onClickBalance } = props;
    return (_jsx(ManaBalancesWrapper, { children: manaBalances &&
            Object.keys(manaBalances).map((network) => (_jsx(Mana, { network: network, href: config.get("ACCOUNT_URL"), onClick: onClickBalance, primary: network === Network.ETHEREUM, children: _jsx(ManaBalanceNumber, { variant: "subtitle2", children: Number(manaBalances[network].toFixed(2)).toLocaleString() }) }, network))) }));
});
export { ManaBalances };
//# sourceMappingURL=ManaBalances.js.map